import { useCallback, useState } from 'react';

import { useEvent } from '@hooks/use-event';

export function usePagination<T>({
  pageSize,
  count,
  defaultPage = 1,
}: {
  pageSize: number;
  count: number;
  defaultPage?: number;
}) {
  const numPages = Math.ceil(count / pageSize);
  const [page, setPage] = useState<number>(defaultPage > numPages ? 1 : defaultPage);

  const getItemsForPage = useCallback(
    (items: Array<T>) => {
      return items.slice((page - 1) * pageSize, pageSize + pageSize * (page - 1));
    },
    [page, pageSize]
  );

  const selectNextPage = useEvent(() => {
    setPage((old) => old + 1);
  });

  const selectPreviousPage = useEvent(() => {
    setPage((old) => old - 1);
  });

  const selectPage = useEvent((pageIndex: number) => {
    setPage(pageIndex);
  });

  return {
    getItemsForPage,
    numPages,
    selectNextPage,
    selectPreviousPage,
    selectPage,
    selectedPage: page,
  };
}
